
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component
export default class ElementProgress extends Vue {
    @Prop({
        required: true,
        type: Number,
    })
    public progress!: number;

    @Prop({
        required: true,
        type: String,
    })
    public status!: string;
}
